import { combineReducers, configureStore } from "@reduxjs/toolkit";
import storage from "redux-persist/lib/storage";
import persistReducer from "redux-persist/es/persistReducer";
import thunk from "redux-thunk";
//Reducers
import userReducer from "./../reducers/users/userSlices";
import servicesSlices from "../reducers/services/servicesSlices";
import authorizationcodeSlices from "../reducers/authorization/authorizationcodeSlices";
import sessionauthcodeSlices from "../reducers/sessions/sessionauthcodeSlices";
import addservicesSlices from "../reducers/services/addservicesSlices";
import codeauthorizationSlices from "../reducers/authorization/codeauthorizationSlices";
import updateautorizacionSlices from "../reducers/authorization/updateautorizacionSlices";
import reprintreportSlice from "../reducers/reports/reprintreport";

const persisConfig = {
  key: "root",
  version: 1,
  storage,
  whitelist: ['user','sessionuser','services','codeauth','updateauth', 'reprint']
}

const rootReducer = combineReducers({
  user: userReducer,
  authcode: authorizationcodeSlices,
  sessionuser: sessionauthcodeSlices,
  services: servicesSlices,
  addservices: addservicesSlices,
  codeauth: codeauthorizationSlices,
  updateauth: updateautorizacionSlices,
  reprint: reprintreportSlice,
})

const persistedReducer = persistReducer(persisConfig, rootReducer)


export const store = configureStore({
  reducer: persistedReducer, 
  middleware: [thunk]
});

export default store

